import moment from 'moment'
import omit from 'ramda/src/omit'
import path from 'ramda/src/path'
import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import clearAllForms from 'root/src/client/logic/form/actions/clearAllForms'
import setLoadingBlockList from 'root/src/client/logic/list/actions/setLoadingBlockList'
import uploadFile from 'root/src/client/util/uploadFile'
import { brandProductTypesEnum } from 'root/src/shared/constants/dropEvent'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'
import { ADD_BRAND_PRODUCT_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { rewardEndpointIds } from 'root/src/shared/rewards/constants'

const errorMessages = {
	ProductAlreadyExists: {
		name: 'Brand already has product with specified name',
	},
}
// eslint-disable-next-line no-unused-vars
export default formData => async (dispatch) => {
	dispatch(setLoadingBlockList(true, ADD_BRAND_PRODUCT_FORM_MODULE_ID))
	const assetFile = path(['asset', 'file'], formData)
	const url = await uploadFile(assetFile, dispatch)

	const { error, body } = await dispatch(
		apiRequest(rewardEndpointIds.ADD_BRAND_CUSTOM_REWARD, { ...omit(['asset'], formData), url }),
	)
	if (error) {
		const { code } = error
		throw errorMessages[code]
	} else {
		dispatch(clearAllForms())
		dispatch(setLoadingBlockList(false, ADD_BRAND_PRODUCT_FORM_MODULE_ID))
	}
	mixpanel.track(mixpanelEvents.brandProducts,
		{ productType: brandProductTypesEnum.customProduct })
	mixpanel.people.set_once({ addedBrandProduct: moment().format() })
	return body
}
